// extracted by mini-css-extract-plugin
export default {"PageNotFound":"PageNotFound_PageNotFound__9gi1-"};